import React from 'react';

import styles from './styles.module.scss';

interface OverlayAvatarsProps {
  avatars: string[];
  width?: number;
  height?: number;
}

const OverlayAvatars = ({ avatars, width = 24, height = 24 }: OverlayAvatarsProps) => (
  <div className={styles.avatars}>
    {avatars.map((avatarUrl) => (
      <span className={styles.avatar} key={avatarUrl}>
        <img src={avatarUrl} width={width} height={height} />
      </span>
    ))}
  </div>
);

export default OverlayAvatars;
